import actions from "actions";
import axios from "axios";
import constants from "constants";
import _, { cloneDeep } from "lodash";
import moment from "moment";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import inputFormatter from "services/userInputFormatter";
import validator from "services/validator";
import shortid from "shortid";
import { sortExpertsByNumeration } from "utils/sort-experts";
import StudyGroupSuperhostEditWebinarForm from "./StudyGroupSuperhostEditWebinarForm";
import { addValidateError } from "../../../actions/api";
import { updateWebinarSagaWithSpeaker } from "../../../actions/webinars";
import { loadSponsorsSuggestionsSaga } from "../../../actions/suggestions";

const { CPD_STATUSES, REF_TYPES } = constants;

const {
  UPDATE_WEBINAR_SAGA,
  MODAL_TYPE_WEBINAR,
  API_ADMIN_WEBINARS,
  CREATE_WEBINAR_SAGA,
} = constants;

const {
  setTempWebinar,
  updateWebinarSaga,
  cleanErrors,
  loadAdminUsersWebinarsSaga,
  loadAdminWebinarSaga,
  showModal,
  adminPostAssignedUsersSaga,
  loadDisciplinesSaga,
  // getSponsorsRepresentatives,
} = actions;

class StudyGroupSuperhostEditWebinar extends Component {
  static propTypes = {
    createWebinar: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj,
  };

  constructor(props) {
    super(props);

    const refTypeUpperCase =
      this.props.webinar.ref_type && this.props.webinar.ref_type.toUpperCase();

    this.state = {
      per_page: 5000,
      page: 1,
      searchQuery: {
        order: {
          created_at: "desc",
        },
      },
      webinar: {
        webinar_type: "online",
        start_date: moment().set(0, "seconds"),
        end_date: moment().set(0, "seconds"),
        webinar_title: "",
        status: "published",
        partnerships_id: "",
        faculty: false,
        generate_qrcode: false,
        price: 0,
        sponsor_ids: [],
        partnerships_ids: [],
        user_sponsor_ids: [],
        int_cpd_points: "",
        ext_cpd_points: "",
        cpd_points: "external",
        vimeo_url: "",
        evaluation_summary: "",
        evaluation_summary_url: "",
        evaluationSummaryType: "",
        gms_study_days: "",
        duration: "",
        join_url: "",
        counties: [],
        disciplines: [],
        search_disciplines: [],
        assignedUsers: [],
        user_types: [],
        ...props.webinar,
        ref_type: REF_TYPES[refTypeUpperCase],
        webinar_type: "online",
        spd_quizzes_attributes: [
          ...(this.props.webinar.spd_quizzes || []),
          {
            question: "",
            correct: false,
          },
        ].map((quiz) => ({ ...quiz, __id: shortid.generate() })),
        sessions_attributes: [
          ...((this.props.webinar.sessions &&
            this.props.webinar.sessions.map((session) => {
              session.rooms_attributes = session.rooms || [
                {
                  title: "",
                },
              ];
              delete session.rooms;
              session.rooms_attributes = session.rooms_attributes.map(
                (room) => ({ ...room, __id: shortid.generate() })
              );
              session.__id = shortid.generate();
              return session;
            })) ||
            [
              {
                title: "",
                start_time: moment().set("seconds", 0),
                end_time: moment().set("seconds", 0),
                rooms_attributes: [
                  {
                    __id: shortid.generate(),
                    title: "",
                  },
                ],
              },
            ].map((session) => ({ ...session, __id: shortid.generate() }))),
        ],
        experts_attributes: [
          ...sortExpertsByNumeration(this.props.webinar.experts || []),
          {
            name: "",
            location: "",
            expert_type: "",
            expert_avatar_url: "",
            numeration: "",
          },
        ].map((expert) => ({ ...expert, __id: shortid.generate() })),
      },
    };
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  componentWillReceiveProps(props) {
    if (
      ((this.props.webinar &&
        this.props.webinar.user_types &&
        this.props.webinar.user_types.length) ||
        0) !==
        ((props.webinar &&
          props.webinar.user_types &&
          props.webinar.user_types.length) ||
          0) &&
      props.webinar.user_types.length !== 0
    ) {
      let fieldValue = cloneDeep(props.webinar.user_types);
      const ipnaMemberIndex = fieldValue.indexOf(8);

      if (ipnaMemberIndex > -1) {
        fieldValue[ipnaMemberIndex] = 2;
      }

      this.props.loadDisciplines(fieldValue);
    }
    if (!_.isEqual(this.props.webinar, props.webinar)) {
      const refTypeUpperCase =
        props.webinar.ref_type && props.webinar.ref_type.toUpperCase();
      let assigned_ids = props.webinar.assigned_ids;

      if (
        props.location.state &&
        props.location.state.from === "addUsersWebinar"
      ) {
        assigned_ids =
          this.state.webinar.assigned_ids || props.webinar.assigned_ids;
      }
      if (assigned_ids && assigned_ids.length) {
        this.props.adminPostAssignedUsersSaga(assigned_ids);
      }

      this.setState({
        webinar: {
          ...this.state.webinar,
          ...props.webinar,
          search_disciplines: props.webinar.search_disciplines,
          start_date: moment(
            props.webinar.start_date || this.state.webinar.start_date
          ),
          assigned_ids,
          assignedUsers:
            props.webinar.assigned_ids || this.props.webinar.assigned_ids,
          end_date: moment(
            props.webinar.end_date || this.state.webinar.end_date
          ),
          spd_quizzes_attributes: [
            ...(props.webinar.spd_quizzes || []),
            {
              question: "",
              correct: false,
            },
          ].map((quiz) => ({ ...quiz, __id: shortid.generate() })),
          sessions_attributes: [
            ...((props.webinar.sessions &&
              props.webinar.sessions.map((session) => {
                session.rooms_attributes = session.rooms || [
                  {
                    title: "",
                  },
                ];
                delete session.rooms;
                session.rooms_attributes = session.rooms_attributes.map(
                  (room) => ({ ...room, __id: shortid.generate() })
                );
                session.__id = shortid.generate();
                return session;
              })) || [
              {
                __id: shortid.generate(),
                title: "",
                start_time: moment().set("seconds", 0),
                end_time: moment().set("seconds", 0),
                rooms_attributes: [
                  {
                    __id: shortid.generate(),
                    title: "",
                  },
                ],
              },
            ]),
          ],
          sponsor_ids:
            props.webinar.sponsor_ids && props.webinar.sponsor_ids.length
              ? props.webinar.sponsor_ids
              : [],
          partnerships_ids:
            props.webinar.partnerships_ids &&
            props.webinar.partnerships_ids.length
              ? props.webinar.partnerships_ids
              : [],
          ref_type: REF_TYPES[refTypeUpperCase],
          experts_attributes: [
            ...sortExpertsByNumeration(props.webinar.experts || []),
            {
              name: "",
              location: "",
              expert_type: "",
              expert_avatar_url: "",
              numeration: "",
            },
          ].map((expert) => ({ ...expert, __id: shortid.generate() })),
        },
      });
    }

    if (!_.isEqual(this.props.users, props.users)) {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            assigned_users: props.users.filter(
              (user) =>
                this.state.webinar.assigned_ids.indexOf(user.id.toString()) > -1
            ),
          },
        },
      });
    }
  }

  componentWillMount() {
    this.props.cleanErrors();
    this.props.loadWebinar(this.props.params.webinarId);
    this.props.loadDisciplines();
    // this.props.getSponsorsRepresentatives();
    this.props.loadAllSponsors();
  }

  onConsultantOrHD = (allCounties) => {
    let newWebinar = {};

    const selectedAllCounties = _.isEqual(
      allCounties,
      this.state.webinar.counties
    );
    if (!this.state.webinar.counties || !selectedAllCounties) {
      newWebinar = {
        ...newWebinar,
        ...{ counties: allCounties.map((county) => county) },
      };
    }

    if (
      this.state.webinar.ext_cpd_points !== 0 &&
      this.state.webinar.int_cpd_points !== 0
    ) {
      newWebinar = {
        ...newWebinar,
        ...{ ext_cpd_points: 0, int_cpd_points: 0 },
      };
    }

    if (!_.isEmpty(newWebinar)) {
      this.setState({ webinar: { ...this.state.webinar, ...newWebinar } });
    }
  };

  onFieldChange = (e) => {
    const fieldValue = [...e.target.value];
    let input = inputFormatter.formatField(e.target.name, e.target.value);

    const webinarData = {
      ...this.state.webinar,
      ...{
        [e.target.name]: input,
      },
    };
    if (e.target.name === "user_types") {
      const ipnaMemberIndex = fieldValue.indexOf(8);

      if (ipnaMemberIndex > -1) {
        fieldValue[ipnaMemberIndex] = 2;
      }

      this.props.loadDisciplines(fieldValue);
    }

    this.setState({ webinar: webinarData });
  };

  onSponsorChange = (sponsor_ids) => {
    this.onFieldChange({
      target: {
        name: "sponsor_ids",
        value: (sponsor_ids || []).map((sponsor) => sponsor.value),
      },
    });
  };

  onPartnerChange = (partnerships_ids) => {
    this.onFieldChange({
      target: {
        name: "partnerships_ids",
        value: (partnerships_ids || []).map((partner) => partner.value),
      },
    });
  };

  onSponsorUsersChange = (user_sponsor_ids) => {
    this.onFieldChange({
      target: {
        name: "user_sponsor_ids",
        value: (user_sponsor_ids || []).map((sponsorUser) => sponsorUser.value),
      },
    });
  };

  onCountiesChange = (counties) => {
    this.onFieldChange({
      target: {
        name: "counties",
        value: (counties || []).map((county) => county.value),
      },
    });
  };

  onUserTypeChange = (roles) => {
    this.onFieldChange({
      target: {
        name: "user_types",
        value: (roles || []).map((role) => role.value),
      },
    });
  };

  onSelectChangeDisciplineWebinar = (disciplines) => {
    this.onFieldChange({
      target: {
        name: "disciplines",
        value: (disciplines || []).map(
          (discipline) => discipline.value || discipline.id
        ),
      },
    });
  };
  onSelectChangeDisciplineWebinarSearch = (disciplines) => {
    this.onFieldChange({
      target: {
        name: "search_disciplines",
        value: (disciplines || []).map(
          (discipline) => discipline.value || discipline.id
        ),
      },
    });
  };

  onNewsletterChange = (e) => {
    const subscription_sponsor = e.target.value;
    this.onFieldChange({
      target: {
        name: "subscription_sponsor",
        value: subscription_sponsor === "true",
      },
    });
  };
  onLandingShowChange = (e) => {
    const landing_show = e.target.value;
    this.onFieldChange({
      target: {
        name: "landing_show",
        value: landing_show === "true",
      },
    });
  };

  onAssignedUsersChange = (assignedUsers) => {
    this.onFieldChange({
      target: {
        name: "assigned_ids",
        value: assignedUsers,
      },
    });
  };

  onWebinarFacultyTypeChange = (e) => {
    if (!e.target.checked) {
      const webinarData = {
        ...this.state.webinar,
        ...{
          price: 0,
          faculty: e.target.checked,
        },
      };
      this.setState({ webinar: webinarData });
    } else {
      const webinarData = {
        ...this.state.webinar,
        ...{
          faculty: e.target.checked,
        },
      };
      this.setState({ webinar: webinarData });
    }
  };

  onCpdPointsChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const cpds = {
      ...(this.state.webinar.cpd_points == "internal"
        ? {
            [e.target.name]: input,
            ext_cpd_points: 0,
          }
        : {}),
      ...(this.state.webinar.cpd_points == "external"
        ? {
            [e.target.name]: input,
            int_cpd_points: 0,
          }
        : {}),
      ...(this.state.webinar.cpd_points == "both"
        ? {
            [e.target.name]: input,
          }
        : {}),
    };
    const webinarData = { ...this.state.webinar, ...cpds };

    this.setState({ webinar: webinarData });
  };

  onCpdTypeChange = (e) => {
    const value = e.target.value;
    this.setState({
      webinar: {
        ...this.state.webinar,
        cpd_status: e.target.value,
        ...(value !== CPD_STATUSES.granted
          ? {
              ext_cpd_points: 0,
              int_cpd_points: 0,
              icgp_ref: this.state.webinar.icgp_ref || "",
            }
          : {}),
      },
    });
  };

  onCertificateRefChange = (e) => {
    const value = e.target.value;
    let refType;

    if (value === REF_TYPES.ICGP) {
      refType = {
        icgp_ref: this.state.webinar.icgp_ref || "",
      };
    } else if (value === REF_TYPES.RCPI) {
      refType = {
        rcpi_ref: this.state.webinar.rcpi_ref || "",
      };
    } else {
      refType = {
        ipna_ref: this.state.webinar.ipna_ref || "",
      };
    }

    this.setState({
      webinar: {
        ...this.state.webinar,
        ref_type: e.target.value,
        ...refType,
      },
    });
  };

  onQuizAdd = () => {
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          spd_quizzes_attributes: [
            ...this.state.webinar.spd_quizzes_attributes,
            ...[{ question: "", correct: false, __id: shortid.generate() }],
          ],
        },
      },
    });
  };

  onQuizRemove = (__id) => {
    let quizzes = this.state.webinar.spd_quizzes_attributes.slice();
    const quiz = quizzes.find((quiz) => quiz.__id == __id);
    if (quiz.id) {
      this.onQuizChange(__id, "_destroy", true);
    } else {
      quizzes = quizzes.filter((quiz) => quiz.__id != __id);
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            spd_quizzes_attributes: quizzes,
          },
        },
      });
    }
  };

  onQuizChange = (__id, field, value) => {
    let cpdQuiz = this.state.webinar.spd_quizzes_attributes.slice();
    let quiz = cpdQuiz.find((webinar) => webinar.__id == __id);
    quiz[field] = value;
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          spd_quizzes_attributes: cpdQuiz,
        },
      },
    });
  };

  // Experts
  onExpertAdd = () => {
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          experts_attributes: [
            ...this.state.webinar.experts_attributes,
            ...[
              {
                name: "",
                type: "",
                location: "",
                avatar: null,
                __id: shortid.generate(),
              },
            ],
          ],
        },
      },
    });
  };

  onExpertRemove = (__id) => {
    let experts = this.state.webinar.experts_attributes.slice();
    const expert = experts.find((expert) => expert.__id == __id);
    if (expert.id) {
      this.onExpertChange(__id, "_destroy", true);
      this.onSpeakerRemoveSubmit();
    } else {
      experts = experts.filter((expert) => expert.__id != __id);
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            experts_attributes: experts,
          },
        },
      });
    }
  };

  onExpertChange = (__id, field, value) => {
    let experts = this.state.webinar.experts_attributes.slice();
    let expert = experts.find((webinar) => webinar.__id == __id);
    expert[field] = value;
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          experts_attributes: experts,
        },
      },
    });
  };

  onEvaluationSummaryChange = (file) => {
    if (Boolean(file)) {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            evaluation_summary: file,
            evaluation_summary_url: URL.createObjectURL(file),
            evaluationSummaryType: file.type,
          },
        },
      });
    } else {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            evaluation_summary: null,
            evaluation_summary_url: "",
            evaluationSummaryType: "",
          },
        },
      });
    }
  };

  cpdPointsFields = () => {
    const { cpd_points, cpd_status } = this.state.webinar;
    if (cpd_status !== CPD_STATUSES.granted) {
      return [];
    }
    switch (cpd_points) {
      case "external":
        return ["ext_cpd_points"];
      case "internal":
        return ["int_cpd_points"];
      case "both":
        return ["int_cpd_points", "ext_cpd_points"];
      default:
        return [];
    }
  };

  onSubmit = async () => {
    try {
      const { webinar } = this.state;

      const isCertificateOfParticipation =
        webinar.ref_type === REF_TYPES.CERTIFICATE_OF_PARTICIPATION;

      const isCustomCertificate = isCertificateOfParticipation;

      if (
        !isCustomCertificate &&
        webinar.spd_quizzes_attributes.filter(
          (e) => !!e.question && !e._destroy
        ).length < 10 &&
        webinar.cpd_status != "not_applicable" &&
        webinar.cpd_status != "applied_for"
      ) {
        toast.error("CPD Quiz should contain >= 10 questions");
        return;
      }

      const {
        history,
        params: { id, webinarId },
      } = this.props;

      let _webinar = cloneDeep(webinar);
      _webinar.start_date = moment(_webinar.start_date);
      _webinar.end_date = moment(_webinar.end_date);
      _webinar.experts_attributes = webinar.experts_attributes.filter(
        (expert) => {
          if (
            typeof expert.expert_avatar_url == "string" ||
            typeof expert.avatar == "string"
          ) {
            expert.expert_avatar_url = null;
            return expert;
          } else {
            return expert;
          }
        }
      );

      if (_webinar.document === "") {
        delete _webinar.document;
        delete _webinar.document_url;
        delete _webinar.attachmentType;
      }

      const formData = getFormData(webinar, id);
      await axios.put(`${API_ADMIN_WEBINARS}/${webinarId}`, formData);
      toast.success("Webinar was successfully updated!");
      this.props.router.push(`/groups/${id}/webinars/all`);
    } catch (error) {
      console.log(error);
      // this.props.dispatch(
      //   addValidateError(
      //     CREATE_WEBINAR_SAGA,
      //     error.response.data.error_messages
      //   )
      // );
    }
  };

  onSpeakerRemoveSubmit = () => {
    const { webinar } = this.state;
    const updatedExperts = webinar.experts_attributes.filter((expert) => {
      if (
        typeof expert.expert_avatar_url == "string" ||
        typeof expert.avatar == "string"
      ) {
        expert.expert_avatar_url = null;
        return expert;
      } else {
        return expert;
      }
    }); // new file, not url
    this.props.updateWebinarRemoveSpeaker({
      ...this.state.webinar,
      experts_attributes: updatedExperts,
    });
    setTimeout(() => {
      this.props.cleanErrors();
      this.props.loadWebinar(this.props.params.webinarId);
      // this.props.loadAllSponsors();
      // this.props.loadAllPartners();
    }, 500);
  };

  goToAddUsersPage = () => {
    this.props.setTempWebinar(this.state.webinar);
    this.props.router.push(
      `/groups/${this.props.params.id}/webinars/${this.props.params.webinarId}/edit/addUsers`
    );
  };
  showUsersModal = (additional = {}) => {
    this.props.showUsersModal(
      {
        users: this.props.users,
      },
      additional
    );
  };
  onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    const reorder = (list, startIndex, endIndex) => {
      const result = Array.from(list);
      const [removed] = result.splice(startIndex, 1);
      result.splice(endIndex, 0, removed);

      return result;
    };

    const speakers = reorder(
      this.state.webinar.experts_attributes,
      result.source.index,
      result.destination.index
    ).map((speaker, index) => {
      speaker.numeration = index + 1;
      return speaker;
    });

    this.setState({
      ...this.state,
      webinar: {
        ...this.state.webinar,
        experts_attributes: speakers,
        experts: speakers.filter((speaker) => speaker.expert_type),
      },
    });
  }

  handleSponsorshipChange = (value) =>
    this.setState((state) => ({
      webinar: { ...state.webinar, is_sponsored: value },
    }));

  // handleSponsorRepresentativeChange = (id) =>
  //   this.setState({
  //     webinar: {
  //       ...this.state.webinar,
  //       sponsor_representative_id: id,
  //     },
  //   });

  handleAudioLink = (audio_link) =>
    this.setState({ webinar: { ...this.state.webinar, audio_link } });

  handleSponsorShipValueChange = (value) =>
    this.setState({
      webinar: { ...this.state.webinar, sponsorship_value: value },
    });

  onWebinarTypeChange = (e) => {
    const webinarData = {
      ...this.state.webinar,
      ...{
        webinar_type: e.target.value,
      },
    };

    this.setState({ webinar: webinarData });
  };

  onDateChange = (field, value) => {
    const webinarData = {
      ...this.state.webinar,
      ...{
        [field]: value,
      },
    };
    this.setState({ webinar: webinarData });
  };

  render() {
    const {
      errors,
      errorsFrontend,
      sponsors,
      partners,
      sponsorUsers,
      // sponsorRepresantive,
    } = this.props;

    // const sponsorRepresantiveData = sponsorRepresantive
    //   ? sponsorRepresantive.data
    //   : [];

    return (
      <main className="site--width clearfix-c">
        <StudyGroupSuperhostEditWebinarForm
          role={this.props.role}
          onSessionChange={this.onSessionChange}
          onFieldChange={this.onFieldChange}
          webinar={this.state.webinar}
          onQuizAdd={this.onQuizAdd}
          onQuizChange={this.onQuizChange}
          onSubmit={this.onSubmit}
          onQuizRemove={this.onQuizRemove}
          errors={validator.formatErrors(errors, errorsFrontend)}
          cpdPointsFields={this.cpdPointsFields()}
          onCpdPointsChange={this.onCpdPointsChange}
          onCountiesChange={this.onCountiesChange}
          onDisciplinesChange={this.onDisciplinesChange}
          onWiminChange={this.onWiminChange}
          goToAddUsersPage={this.goToAddUsersPage}
          onAssignedUsersChange={this.onAssignedUsersChange}
          onUserTypeChange={this.onUserTypeChange}
          onCpdTypeChange={this.onCpdTypeChange}
          onCertificateRefChange={this.onCertificateRefChange}
          sponsorsOptions={sponsors}
          partnersOptions={partners}
          search_disciplines={this.props.search_disciplines}
          sponsorUsersOptions={sponsorUsers}
          onConsultantOrHD={this.onConsultantOrHD}
          onWebinarTypeChange={this.onWebinarTypeChange}
          onExpertAdd={this.onExpertAdd}
          onExpertRemove={this.onExpertRemove}
          onExpertChange={this.onExpertChange}
          onSponsorChange={this.onSponsorChange}
          onSponsorUsersChange={this.onSponsorUsersChange}
          showUsersModal={this.showUsersModal}
          onPartnerChange={this.onPartnerChange}
          onWebinarFacultyTypeChange={this.onWebinarFacultyTypeChange}
          evaluation_summary={this.state.webinar.evaluation_summary}
          evaluation_summary_url={this.state.webinar.evaluation_summary_url}
          evaluationSummaryType={this.state.webinar.evaluationSummaryType}
          onEvaluationSummaryChange={this.onEvaluationSummaryChange}
          disciplines={this.props.disciplines}
          onSelectChangeDiscipline={this.onSelectChangeDisciplineWebinar}
          onSelectChangeDisciplineSearch={
            this.onSelectChangeDisciplineWebinarSearch
          }
          onLandingShowChange={this.onLandingShowChange}
          onEventWebinarChange={this.onEventWebinarChange}
          onDragEnd={this.onDragEnd}
          onNewsletterChange={this.onNewsletterChange}
          handleSponsorshipChange={this.handleSponsorshipChange}
          // handleSponsorRepresentativeChange={
          //   this.handleSponsorRepresentativeChange
          // }
          // sponsorsRepresentative={sponsorRepresantiveData}
          handleAudioLink={this.handleAudioLink}
          handleSponsorShipValueChange={this.handleSponsorShipValueChange}
          onDateChange={this.onDateChange}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    errors: state.errors[UPDATE_WEBINAR_SAGA],
    sponsors: state.suggestions.sponsor.values,
    errorsFrontend: state.errors[`${UPDATE_WEBINAR_SAGA}_FRONTEND`],
    users: state.users.assignedUsers.values,
    webinar: state.webinars.tmp,
    disciplines: state.disciplines.list.values,
    count: state.disciplines.list.count,
    total_pages: state.disciplines.list.total_pages,
    page: state.disciplines.list.page,
    query: state.disciplines.list.query,
    search_disciplines: state.disciplines.search.values,
    role: state.users.user.role,
    // sponsorRepresantive: state.users.sponsorRepresantive,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setTempWebinar: (webinar) => dispatch(setTempWebinar(webinar)),
    updateWebinar: (webinar) => dispatch(updateWebinarSaga(webinar)),
    cleanErrors: () => dispatch(cleanErrors(UPDATE_WEBINAR_SAGA)),
    loadAllSponsors: () => dispatch(loadSponsorsSuggestionsSaga()),
    loadWebinar: (id) => dispatch(loadAdminWebinarSaga(id, true)),
    loadAdminUsersWebinar: (id) => dispatch(loadAdminUsersWebinarsSaga(id)),
    showUsersModal: (contentProps) =>
      dispatch(showModal(MODAL_TYPE_WEBINAR, contentProps)),
    adminPostAssignedUsersSaga: (assigned_ids, onlyAssigned = true) =>
      dispatch(
        adminPostAssignedUsersSaga(assigned_ids, onlyAssigned, 1, {}, 500)
      ),
    dispatch: dispatch,
    loadDisciplines: (userType) =>
      dispatch(loadDisciplinesSaga(1, { discipline_type: userType })),
    // getSponsorsRepresentatives: () => dispatch(getSponsorsRepresentatives()),
    updateWebinarRemoveSpeaker: (webinar) =>
      dispatch(updateWebinarSagaWithSpeaker(webinar)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupSuperhostEditWebinar);

const getFormData = (webinar, group_id) => {
  const {
    webinar_title,
    audio_link,
    status,
    cpd_status,
    cpd_points,
    int_cpd_points,
    ext_cpd_points,
    assigned_ids,
    icgp_ref,
    ipna_ref,
    ref_type,
    rcpi_ref,
    spd_quizzes_attributes,
    experts_attributes,
    gms_study_days,
    is_sponsored,
    sponsorship_value,
    // sponsor_representative_id,
    search_disciplines,
    webinar_type,
    start_date,
    end_date,
    join_url,
    sponsor_ids,
  } = webinar;

  const formdata = new FormData();

  const isCertificateOfParticipation =
    ref_type === REF_TYPES.CERTIFICATE_OF_PARTICIPATION;

  const isCustomCertificate = isCertificateOfParticipation;

  formdata.append("webinar[group_id]", group_id);
  formdata.append("webinar[webinar_title]", webinar_title);
  formdata.append("webinar[webinar_type]", webinar_type);
  formdata.append("webinar[status]", status);
  formdata.append("webinar[cpd_status]", cpd_status);

  if (!isCustomCertificate) {
    formdata.append("webinar[cpd_points]", cpd_points);
    formdata.append("webinar[int_cpd_points]", int_cpd_points);
    formdata.append("webinar[ext_cpd_points]", ext_cpd_points);
  }

  if (webinar_type === "audio") {
    formdata.append("webinar[audio_link]", audio_link);
  }

  if (webinar_type === "online") {
    formdata.append("webinar[start_date]", start_date);
    formdata.append("webinar[end_date]", end_date);
    formdata.append("webinar[join_url]", join_url);
  }

  if (assigned_ids.length) {
    for (const id of assigned_ids) {
      formdata.append("webinar[assigned_ids][]", id);
    }
  }

  if (search_disciplines.length) {
    for (const id of search_disciplines) {
      formdata.append("webinar[search_discipline_ids][]", id);
    }
  }

  if (sponsor_ids.length) {
    for (const id of sponsor_ids) {
      formdata.append("webinar[sponsor_ids][]", id);
    }
  }

  formdata.append("webinar[icgp_ref]", icgp_ref);
  formdata.append("webinar[ipna_ref]", ipna_ref);
  formdata.append("webinar[ref_type]", ref_type);
  formdata.append("webinar[rcpi_ref]", rcpi_ref);
  // formdata.append("webinar[evaluation_summary]", evaluation_summary); next
  const quizz = spd_quizzes_attributes.filter(({ question }) => question);
  if (quizz.length) {
    for (const { id, question, correct, _destroy } of quizz) {
      if (id) formdata.append("webinar[spd_quizzes_attributes[]][id]", id);
      if (_destroy) formdata.append("webinar[spd_quizzes_attributes[]][_destroy]", _destroy);
      formdata.append("webinar[spd_quizzes_attributes[]][question]", question);
      formdata.append("webinar[spd_quizzes_attributes[]][correct]", correct);
    }
  }

  const expert = experts_attributes.filter(({ name }) => name);
  if (expert.length) {
    for (const {
      id,
      name,
      expert_type,
      location,
      expert_avatar_url,
      numeration,
      presentation_title,
    } of expert) {
      if (id) formdata.append("webinar[experts_attributes[]id]", id);
      formdata.append("webinar[experts_attributes[]name]", name);
      formdata.append("webinar[experts_attributes[]location]", location);
      formdata.append("webinar[experts_attributes[]expert_type]", expert_type);
      formdata.append(
        "webinar[experts_attributes[]presentation_title]",
        presentation_title
      );
      formdata.append("webinar[experts_attributes[]numeration]", numeration);
      if (expert_avatar_url) formdata.append("webinar[experts_attributes[]avatar]", expert_avatar_url);
    }
  }

  formdata.append("webinar[gms_study_days]", gms_study_days);
  if (is_sponsored) {
    formdata.append("webinar[is_sponsored]", is_sponsored);
    formdata.append("webinar[sponsorship_value]", sponsorship_value);
    // formdata.append(
    //   "webinar[sponsor_representative_id]",
    //   sponsor_representative_id
    // );
  }

  return formdata;
};



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/StudyGroupSuperhostEditWebinar/index.jsx